/**
 * The box every house field control draws at each size: height, radius,
 * border, text size, vertical padding and focus ring. SelectField and
 * DateInput both read it, so a date box beside a select on one filter
 * line is the same height with the same edge. Horizontal padding is each
 * control's own (the select keeps room for its chevron).
 *
 * All in rem, so the box follows the reader's text size.
 */
export const FIELD_BOX = {
  field:
    'min-h-[2.875rem] rounded-xl border border-sage-400/20 py-2 text-[0.90625rem] ' +
    'outline-none focus:border-sage-400 focus:ring-[3px] focus:ring-sage-800/[6%]',
  default:
    'min-h-11 rounded-base border border-sage-300 py-2 text-sm hover:border-sage-400 ' +
    'focus:border-sage-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400',
  compact:
    'min-h-[2.34375rem] rounded-base border border-sage-300 py-1 text-[0.8125rem] hover:border-sage-400 ' +
    'focus:border-sage-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sage-400',
} as const;

export type FieldBoxSize = keyof typeof FIELD_BOX;
